import dayjs from "dayjs";
import {cloneDeep, isNil} from "lodash-es";
declare const AnalysysAgent: any;

export const covertField = (
    target: any,
    fields = [
      'enter_time',
      'leave_time',
      'start_time',
      'execute_time',
      'task_id',
      'task_name',
      'value_chain_name',
      'value_chain_id',
      'scene_name',
      'scene_id',
    ],
) => {
  const res = cloneDeep(target);
  for (const snakeKey of fields) {
    // 下划线格式转驼峰格式
    const camelKey = snakeKey.split('_').reduce((result, str, i) => {
      const _str = str.split('');
      if (i > 0) {
        _str[0] = _str[0].toUpperCase();
      }
      result += _str.join('');
      return result;
    }, '');
    // console.log(target, camelKey);
    if (!isNil(target[camelKey]) && target[camelKey] !== '') {
      res[snakeKey] = target[camelKey];
    }
    delete res[camelKey];
  }
  return res;
};

export const track = (eventName: string, eventInfo: any) => {
  const _info = covertField(eventInfo);
  if (['task_page_view', 'task_page_close', 'task_execute'].includes(eventName)) {
    _info['path'] = location.href;
  }

  if (eventName === 'task_execute') {
    _info.duration = _info.duration || dayjs(_info['execute_time']).diff(_info['start_time'], 'seconds');
  }
  // console.log(eventName, _info);
  if (AnalysysAgent) {
    const workNumber = AnalysysAgent.getSuperProperty('work_number');
    if (!isNil(workNumber)) {
      AnalysysAgent.track(eventName, _info);
    } else {
      console.error('workNumber is Nil');
    }
  }
};

/* 格式化数字  百分率 价格 */
export const numFormat = ({ type = 'decimal', value, minDig = 2, maxDig = 2 }) => {
  if (!value || value == 0 || value == Infinity) {
    return '-';
  }
  if (value == '/') {
    return '/';
  }
  switch (type) {
    case 'rate':
      const rateFormat = Intl.NumberFormat('zh-CN', {
        style: 'percent',
        minimumFractionDigits: minDig,
        maximumFractionDigits: maxDig,
      });
      return rateFormat.format(value);
    default:
      const numberFormat = Intl.NumberFormat('zh-CN', {
        style: type,
        minimumFractionDigits: minDig,
        maximumFractionDigits: maxDig,
      });
      return numberFormat.format(value);
  }
};

export default track;